export default "__VITE_ASSET__BDpoGcdC__"